/**
 * 系统公告服务
 */
import apiRequest from '@/utils/apiRequest';

/**
 * 公告数据类型
 */
export interface Announcement {
  id: number;
  title: string;
  content: string;
  type: string;           // MARQUEE | POPUP
  platform: string;       // CLIENT | ALL
  enabled: boolean;
  priority: number;
  startTime?: string;
  endTime?: string;
  requireConfirm: boolean;
  confirmButtonText: string;
}

/**
 * 获取跑马灯公告列表
 */
export async function getMarquee(signal?: AbortSignal): Promise<Announcement[]> {
  return apiRequest<Announcement[]>('/announcement/marquee', {
    method: 'GET',
    signal,
  });
}

/**
 * 获取未读弹窗公告列表
 */
export async function getPopups(signal?: AbortSignal): Promise<Announcement[]> {
  return apiRequest<Announcement[]>('/announcement/popups', {
    method: 'GET',
    signal,
  });
}

/**
 * 标记公告为已读
 */
export async function markAsRead(id: number, signal?: AbortSignal): Promise<void> {
  return apiRequest<void>(`/announcement/read/${id}`, {
    method: 'POST',
    signal,
  });
}
